import { SiteExp, User } from '@groma-dev/scaffold';
import { OnboardingProgress } from '../../core/apiclient/APIClientInterface';
import { OnboardingRoutes } from '../../core/routes/OnboardingRoutes';
import { AppConfig } from '../../core/AppConfig';
import { ENTITY_SUPPORT_ENABLED } from '../../core/constants/featureFlags';

export type OnboardingResumeResult = { type: 'route'; path: string } | { type: 'phone_verification' } | null;

export function getOnboardingResumeRoute(progress: OnboardingProgress, user: User): OnboardingResumeResult {
  if (!progress.email_verified) {
    return { type: 'route', path: OnboardingRoutes.VerifyEmail };
  }

  if (!user.phone_number_verified) {
    return { type: 'phone_verification' };
  }

  if (progress.has_claim_awaiting_onboarding && !progress.identity_verified) {
    return { type: 'route', path: OnboardingRoutes.ClaimVerifyIdentity };
  }

  if (!progress.identity_verified) {
    return { type: 'route', path: OnboardingRoutes.CreateAccount };
  }

  if (!progress.has_investment_account) {
    return { type: 'route', path: OnboardingRoutes.CreateAccount };
  }

  if (
    ENTITY_SUPPORT_ENABLED &&
    progress.investment_account_type !== 'Individual' &&
    !progress.entity_details_complete
  ) {
    return { type: 'route', path: OnboardingRoutes.AddEntityDetails };
  }

  return null;
}

export function redirectToPhoneVerification(pathname: string, search: string): null {
  const { Domains } = AppConfig.Settings;
  const returnUrl = encodeURIComponent(`${pathname}${search}`);
  window.location.href = `${Domains.id.baseUrl}/verification/phone?site_exp=${SiteExp.INVESTORS}&return_url=${returnUrl}`;
  return null;
}

export function isOnboardingComplete(progress: OnboardingProgress): boolean {
  if (!progress.email_verified || !progress.has_investment_account || !progress.identity_verified) {
    return false;
  }

  if (progress.investment_account_type === 'Individual') {
    return true;
  }

  return !ENTITY_SUPPORT_ENABLED || progress.entity_details_complete;
}
